(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["callout-row-figma"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-callout-carousel]').forEach((carousel) => {
    const slides = carousel.querySelector('.callout-row-figma__slides');
    const amount = () => carousel.clientWidth;
    carousel.querySelector('[data-callout-previous]')?.addEventListener('click', () => slides.scrollBy({ left: -amount(), behavior: 'smooth' }));
    carousel.querySelector('[data-callout-next]')?.addEventListener('click', () => slides.scrollBy({ left: amount(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["description-with-video-figma"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeVideoMedia = () => document.querySelectorAll('[data-video-media]').forEach((media) => {
      if (media.dataset.videoInitialized === 'true') return;

      const playButton = media.querySelector('[data-video-play]');
      const video = media.querySelector('video');
      const externalVideo = media.querySelector('.centennial-description-video-figma__external-video');
      if (!playButton || (!video && !externalVideo)) return;

      media.dataset.videoInitialized = 'true';

      const showPoster = () => {
        media.classList.remove('centennial-description-video-figma--playing');
        playButton.hidden = false;
        playButton.disabled = false;
      };

      playButton.addEventListener('click', () => {
        media.classList.add('centennial-description-video-figma--playing');
        playButton.hidden = true;

        if (video) {
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(showPoster);
          }
        }
      });

      if (video) {
        video.addEventListener('error', showPoster);
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeVideoMedia, { once: true });
    } else {
      initializeVideoMedia();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer-old"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-and-contact-info"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sourceFieldPattern = /source[\s_-]*page[\s_-]*url/i;
    const sourceFieldLabelPattern = /^\s*source\s+page\s+url\s*$/i;
    const sectionSelector = '.form-and-contact-info';
    const rootSelector = '[data-forms-id="forms-root-1110187"]';

    const visitRoots = (root, callback) => {
      callback(root);
      root.querySelectorAll('*').forEach((element) => {
        if (element.shadowRoot) visitRoots(element.shadowRoot, callback);
      });
    };

    const controlsIn = (root) => {
      const controls = [];
      visitRoots(root, (scope) => {
        controls.push(...scope.querySelectorAll('input, textarea, [contenteditable="true"], [role="textbox"]'));
      });
      return controls;
    };

    const textFor = (element) => [
      element.name,
      element.id,
      element.getAttribute('aria-label'),
      element.getAttribute('placeholder'),
      element.textContent
    ].filter(Boolean).join(' ');

    const findSourceControl = (section) => {
      const roots = [...section.querySelectorAll(rootSelector)];
      const scopes = roots.length ? roots : [section];
      for (const scope of scopes) {
        const controls = controlsIn(scope);
        const directMatch = controls.find((control) => sourceFieldPattern.test(textFor(control)));
        if (directMatch) return directMatch;
        for (const control of controls) {
          let ancestor = control.parentElement;
          for (let depth = 0; ancestor && depth < 6; depth += 1, ancestor = ancestor.parentElement) {
            if (sourceFieldLabelPattern.test((ancestor.textContent || '').trim())) return control;
          }
        }
        let match = null;
        visitRoots(scope, (root) => {
          if (match) return;
          root.querySelectorAll('*').forEach((element) => {
            if (match || !sourceFieldLabelPattern.test((element.textContent || '').trim())) return;
            const container = element.closest('label') || element.parentElement;
            const control = container && controlsIn(container)[0];
            if (control) match = control;
          });
        });
        if (match) return match;
      }
      return null;
    };

    const populateAndHide = (section) => {
      const field = findSourceControl(section);
      if (!field) return false;
      const pageUrl = window.location.href;
      if ('value' in field && field.value !== pageUrl) {
        field.value = pageUrl;
        field.setAttribute('value', pageUrl);
        field.dispatchEvent(new Event('input', { bubbles: true }));
        field.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (field.isContentEditable && field.textContent !== pageUrl) {
        field.textContent = pageUrl;
        field.dispatchEvent(new InputEvent('input', { bubbles: true, inputType: 'insertText', data: pageUrl }));
      }
      const component = field.closest('[data-testid="form-component"]') || field.closest('label') || field.parentElement;
      field.setAttribute('data-source-page-url-field', 'true');
      field.hidden = true;
      field.setAttribute('aria-hidden', 'true');
      if (component) {
        component.setAttribute('data-source-page-url-field', 'true');
        component.hidden = true;
        component.style.setProperty('display', 'none', 'important');
      }
      return true;
    };

    let scheduled = false;
    const initialize = () => {
      scheduled = false;
      document.querySelectorAll(sectionSelector).forEach(populateAndHide);
    };
    const scheduleInitialize = () => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', scheduleInitialize, { once: true });
    } else {
      scheduleInitialize();
    }

    new MutationObserver(scheduleInitialize).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('submit', (event) => {
      const section = event.target.closest(sectionSelector);
      if (section) populateAndHide(section);
    }, true);
  })();

  (() => {
    document.querySelectorAll('[data-centennial-project-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const status = form.querySelector('[data-centennial-form-status]');
      const upload = form.querySelector('[data-project-upload]');
      const input = upload && upload.querySelector('[data-project-upload-input]');
      const uploadStatus = upload && upload.querySelector('[data-project-upload-status]');
      const endpoint = upload && upload.dataset.uploadEndpoint;
      const setStatus = (message, state) => {
        status.textContent = message;
        status.dataset.state = state || '';
      };

      input?.addEventListener('change', () => {
        const count = input.files ? input.files.length : 0;
        uploadStatus.textContent = count ? `${count} file${count === 1 ? '' : 's'} selected.` : '';
        uploadStatus.dataset.state = '';
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.submitting === 'true') return;
        if (!form.reportValidity()) return;
        const files = input ? Array.from(input.files || []) : [];
        if (!files.length) {
          uploadStatus.textContent = 'Please choose at least one image or video.';
          uploadStatus.dataset.state = 'error';
          input?.focus();
          return;
        }

        form.dataset.submitting = 'true';
        form.querySelector('button[type="submit"]')?.setAttribute('disabled', 'disabled');
        setStatus('Uploading your files…', 'loading');
        const payload = new FormData(form);
        payload.append('idempotency_key', `${Date.now()}-${crypto.randomUUID()}`);
        files.forEach((file) => payload.append('files', file, file.name));

        try {
          const response = await fetch(endpoint, { method: 'POST', body: payload });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.error || 'The submission could not be sent.');
          form.innerHTML = `<div class="centennial-native-form__success"><h3>Thank you</h3><p>Your project has been submitted. Our team will be in touch soon.</p></div>`;
        } catch (error) {
          form.dataset.submitting = 'false';
          form.querySelector('button[type="submit"]')?.removeAttribute('disabled');
          setStatus(error.message || 'The submission could not be sent. Please try again.', 'error');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["form-file-upload"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-centennial-project-form]').forEach((form) => {
      if (form.dataset.ready === 'true') return;
      form.dataset.ready = 'true';
      const status = form.querySelector('[data-centennial-form-status]');
      const upload = form.querySelector('[data-project-upload]');
      const input = upload && upload.querySelector('[data-project-upload-input]');
      const uploadStatus = upload && upload.querySelector('[data-project-upload-status]');
      const endpoint = upload && upload.dataset.uploadEndpoint;
      const setStatus = (message, state) => {
        status.textContent = message;
        status.dataset.state = state || '';
      };

      input?.addEventListener('change', () => {
        const count = input.files ? input.files.length : 0;
        uploadStatus.textContent = count ? `${count} file${count === 1 ? '' : 's'} selected.` : '';
        uploadStatus.dataset.state = '';
      });

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (form.dataset.submitting === 'true' || !form.reportValidity()) return;
        const files = input ? Array.from(input.files || []) : [];
        if (!files.length) {
          uploadStatus.textContent = 'Please choose at least one image or video.';
          uploadStatus.dataset.state = 'error';
          input?.focus();
          return;
        }

        form.dataset.submitting = 'true';
        form.querySelector('button[type="submit"]')?.setAttribute('disabled', 'disabled');
        setStatus('Uploading your files…', 'loading');
        const payload = new FormData(form);
        payload.append('idempotency_key', `${Date.now()}-${crypto.randomUUID()}`);
        files.forEach((file) => payload.append('files', file, file.name));

        try {
          const response = await fetch(endpoint, { method: 'POST', body: payload });
          const result = await response.json().catch(() => ({}));
          if (!response.ok) throw new Error(result.error || 'The submission could not be sent.');
          form.innerHTML = '<div class="centennial-native-form__success"><h3>Thank you</h3><p>Your project has been submitted. Our team will be in touch soon.</p></div>';
        } catch (error) {
          form.dataset.submitting = 'false';
          form.querySelector('button[type="submit"]')?.removeAttribute('disabled');
          setStatus(error.message || 'The submission could not be sent. Please try again.', 'error');
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-old"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }


      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["large-gallery-figma"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const galleries = document.querySelectorAll('[data-large-gallery]');

    galleries.forEach((gallery) => {
      if (gallery.dataset.initialized === 'true') return;
      gallery.dataset.initialized = 'true';

      const track = gallery.querySelector('[data-gallery-track]');
      const slides = Array.from(gallery.querySelectorAll('[data-gallery-slide]'));
      const dots = Array.from(gallery.querySelectorAll('[data-gallery-dot]'));
      const previous = gallery.querySelector('[data-gallery-previous]');
      const next = gallery.querySelector('[data-gallery-next]');

      if (!track || slides.length === 0) return;

      const setActive = (index) => {
        dots.forEach((dot, dotIndex) => {
          const active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
          dot.tabIndex = active ? 0 : -1;
        });
      };

      const goTo = (index) => {
        const safeIndex = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({ left: slides[safeIndex].offsetLeft, behavior: 'smooth' });
        setActive(safeIndex);
      };

      previous?.addEventListener('click', () => {
        const activeIndex = dots.findIndex((dot) => dot.classList.contains('is-active'));
        goTo(Math.max(0, activeIndex - 1));
      });

      next?.addEventListener('click', () => {
        const activeIndex = dots.findIndex((dot) => dot.classList.contains('is-active'));
        goTo(Math.min(slides.length - 1, activeIndex + 1));
      });

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => goTo(index));
        dot.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            goTo(Math.max(0, index - 1));
            dots[Math.max(0, index - 1)]?.focus();
          }
          if (event.key === 'ArrowRight') {
            event.preventDefault();
            goTo(Math.min(slides.length - 1, index + 1));
            dots[Math.min(slides.length - 1, index + 1)]?.focus();
          }
        });
      });

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(slides.indexOf(entry.target));
        });
      }, { root: track, threshold: 0.6 });

      slides.forEach((slide) => observer.observe(slide));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-blogs-figma"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('centennial-related-video')) {
    customElements.define('centennial-related-video', class extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('button');
        this.activate = this.activate || (() => {
          const template = this.querySelector('template');
          if (!template || !this.trigger) return;
          const player = template.content.firstElementChild.cloneNode(true);
          this.trigger.replaceWith(player);
          this.trigger = null;
          player.focus({ preventScroll: true });
          if (player.tagName === 'VIDEO') player.play().catch(() => {});
        });
        this.trigger?.addEventListener('click', this.activate);
      }
      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.activate);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-contact-us-contact"] && !Shopify.designMode) return;
  try {
    
  const formRootSelector = '[data-forms-id="forms-root-1110187"]';
  const formEmbedSelector = '.centennial-shopify-form shopify-forms-embed';
  const injectedStyleId = 'centennial-contact-form-styles';
  const formStyles = `
    :host {
      display: block !important;
      width: 100% !important;
      max-width: 534px !important;
      color: #252525 !important;
      font-family: "Open Sans", sans-serif !important;
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }

    #app-embed,
    #form-container-ref,
    form,
    [data-sizing="form-wrapper"] {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
    }

    [class*="_formFieldContainer_"] {
      width: 100% !important;
      min-width: 0 !important;
    }

    h1, h2, h3, h4, h5, h6 {
      color: #252525 !important;
      font-family: "Montserrat", sans-serif !important;
      font-weight: 700 !important;
      letter-spacing: 0.2px !important;
      text-align: left !important;
      text-transform: uppercase !important;
    }

    h1, h2 {
      margin: 0 0 48px !important;
      font-size: 26px !important;
      line-height: 1.3 !important;
    }

    p, span, div, label, legend, input, textarea, select, button {
      font-family: "Montserrat", sans-serif !important;
    }

    label, legend {
      color: #3f3f3f !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      letter-spacing: 0.01em !important;
    }

    form[class*="_formFieldset_"] {
      gap: 24px !important;
    }

    [class*="_formFieldContainer_"] {
      gap: 16px !important;
    }

    label[class*="_formInputFieldLabel_"] {
      position: static !important;
      order: -1 !important;
      width: auto !important;
      max-width: none !important;
      margin: 0 !important;
      color: #459b45 !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      line-height: 1.2 !important;
      pointer-events: auto !important;
      transform: none !important;
      transition: none !important;
    }

    [class*="_formFieldContainer_"]:focus-within label[class*="_formInputFieldLabel_"],
    [class*="_formFieldContainer_"] label[class*="_inputFilled_"] {
      width: auto !important;
      transform: none !important;
    }

    input:not([type="checkbox"]):not([type="radio"]),
    textarea,
    select {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      height: 50px !important;
      min-height: 50px !important;
      border: 1px solid #459b45 !important;
      border-radius: 4px !important;
      background: #ffffff !important;
      color: #252525 !important;
      font-size: 16px !important;
      font-weight: 500 !important;
      line-height: 1.3 !important;
      box-shadow: none !important;
      transition: none !important;
    }

    input:not([type="checkbox"]):not([type="radio"]) {
      padding: 0 16px !important;
      line-height: 48px !important;
    }

    input:not([type="checkbox"]):not([type="radio"]):focus-visible,
    textarea:focus-visible,
    select:focus-visible {
      border-color: #459b45 !important;
      outline: 2px solid transparent !important;
      box-shadow: 0 0 0 2px rgb(69 155 69 / 20%) !important;
    }

    textarea {
      height: 150px !important;
      min-height: 150px !important;
      padding: 16px !important;
      resize: vertical !important;
    }

    [class*="_formFieldContainer_"]:has(textarea)::before {
      display: none !important;
    }

    [class*="_formFieldContainer_"] textarea,
    [class*="_formFieldContainer_"]:focus-within textarea,
    [class*="_formFieldContainer_"] [class*="_inputFilled_"] textarea {
      padding: 16px !important;
    }

    input[type="checkbox"],
    input[type="radio"] {
      accent-color: #459b45 !important;
    }

    [class*="_formPhoneInputContainer_"] {
      display: grid !important;
      grid-template-columns: 92px minmax(0, 1fr) !important;
      gap: 12px !important;
      align-items: end !important;
      width: 100% !important;
    }

    [class*="_formPhoneInputContainer_"] .phone-country-selector {
      width: 92px !important;
      min-width: 92px !important;
    }

    [class*="_formPhoneInputContainer_"] .phone-country-selector button {
      height: 50px !important;
      min-height: 50px !important;
      box-sizing: border-box !important;
      border: 1px solid #459b45 !important;
      border-radius: 4px !important;
      transition: none !important;
    }

    [class*="_formPhoneInputContainer_"] .phone-country-selector + * {
      min-width: 0 !important;
      width: 100% !important;
    }

    [class*="_formPhoneInputContainer_"] input[type="tel"] {
      min-width: 0 !important;
      width: 100% !important;
    }

    fieldset:has(input[type="radio"]) {
      border: 0 !important;
      padding: 0 !important;
    }

    fieldset:has(input[type="radio"]) > div {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 16px !important;
    }

    label:has(input[type="radio"]) {
      position: relative !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      min-height: 40px !important;
      border: 1px solid #8a8b8d !important;
      border-radius: 4px !important;
      color: #3f3f3f !important;
      text-align: center !important;
      cursor: pointer !important;
    }

    label:has(input[type="radio"]):has(input:checked) {
      border-color: #459b45 !important;
      background: #459b45 !important;
      color: #ffffff !important;
    }

    label:has(input[type="radio"]):has(input:checked) * {
      color: #ffffff !important;
    }

    label:has(input[type="radio"]) input {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      opacity: 0 !important;
    }

    button[type="submit"] {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      height: 75px !important;
      min-height: 75px !important;
      box-sizing: border-box !important;
      padding: 0 !important;
      border: 1px solid #5bb65b !important;
      border-radius: 4px !important;
      background: #5bb65b !important;
      color: #ffffff !important;
      font-size: 20px !important;
      font-weight: 700 !important;
      letter-spacing: 0.02em !important;
      line-height: 1 !important;
      text-transform: uppercase !important;
      cursor: pointer !important;
      transition: none !important;
    }

    .centennial-required-marker {
      margin-left: 2px !important;
      color: #459b45 !important;
    }

    .centennial-required-message {
      display: none !important;
      margin-left: 8px !important;
      color: #c62828 !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      line-height: 1.2 !important;
    }

    [class*="_formFieldContainer_"].centennial-required-missing input:not([type="checkbox"]):not([type="radio"]),
    [class*="_formFieldContainer_"].centennial-required-missing textarea {
      border-color: #c62828 !important;
      box-shadow: none !important;
    }

    [class*="_formFieldContainer_"].centennial-required-missing .centennial-required-marker,
    fieldset.centennial-required-missing .centennial-required-marker {
      color: #c62828 !important;
    }

    [class*="_formFieldContainer_"].centennial-required-missing .centennial-required-message,
    fieldset.centennial-required-missing .centennial-required-message {
      display: inline !important;
    }

    fieldset.centennial-required-missing label:has(input[type="radio"]) {
      border-color: #c62828 !important;
    }

    .centennial-required-missing > output[role="alert"],
    .centennial-required-missing + output[role="alert"] {
      display: none !important;
    }

    button[type="submit"]:hover {
      border-color: #459b45 !important;
      background: #459b45 !important;
      box-shadow: 0 6px 16px rgb(34 102 34 / 22%) !important;
    }

    button[type="submit"]:focus-visible {
      outline: 2px solid #252525 !important;
      outline-offset: 3px !important;
    }

    a {
      color: #459b45 !important;
    }

    @media (max-width: 479px) {
      [class*="_formPhoneInputContainer_"] {
        grid-template-columns: 82px minmax(0, 1fr) !important;
        gap: 8px !important;
      }

      [class*="_formPhoneInputContainer_"] .phone-country-selector {
        width: 82px !important;
        min-width: 82px !important;
      }

      fieldset:has(input[type="radio"]) > div {
        grid-template-columns: 1fr !important;
        gap: 8px !important;
      }

      button[type="submit"] {
        font-size: 18px !important;
      }
    }
  `;

  function configureFormRoot() {
    const formRoot = document.querySelector(formRootSelector);
    if (!formRoot) return;
    formRoot.dataset.formsTextColor = '#252525';
    formRoot.dataset.formsButtonBackgroundColor = '#5BB65B';
    formRoot.dataset.formsButtonLabelColor = '#FFFFFF';
    formRoot.dataset.formsLinksColor = '#459B45';
    formRoot.dataset.formsTextAlignment = 'left';
    formRoot.dataset.formsAlignment = 'left';
  }

  function addRequiredStatus(label) {
    if (!label || label.querySelector('.centennial-required-marker')) return;
    const marker = document.createElement('span');
    marker.className = 'centennial-required-marker';
    marker.setAttribute('aria-hidden', 'true');
    marker.textContent = '*';
    const message = document.createElement('span');
    message.className = 'centennial-required-message';
    message.textContent = 'Required';
    label.append(marker, message);
  }

  function configureRequiredValidation(shadowRoot) {
    const form = shadowRoot.querySelector('form');
    if (!form) {
      if (!shadowRoot.centennialRequiredObserver) {
        shadowRoot.centennialRequiredObserver = new MutationObserver(() => {
          if (shadowRoot.querySelector('form')) {
            shadowRoot.centennialRequiredObserver.disconnect();
            configureRequiredValidation(shadowRoot);
          }
        });
        shadowRoot.centennialRequiredObserver.observe(shadowRoot, { childList: true, subtree: true });
      }
      return;
    }

    const fieldContainers = [...form.querySelectorAll('[class*="_formFieldContainer_"]')].filter((container) => {
      return container.querySelector('input:not([type="checkbox"]):not([type="radio"]), textarea');
    });
    const radioFieldsets = [...form.querySelectorAll('fieldset')].filter((fieldset) => fieldset.querySelector('input[type="radio"]'));

    fieldContainers.forEach((container) => addRequiredStatus(container.querySelector('label[class*="_formInputFieldLabel_"]')));
    radioFieldsets.forEach((fieldset) => addRequiredStatus(fieldset.querySelector('legend')));

    const syncMissingFields = () => {
      fieldContainers.forEach((container) => {
        const control = container.querySelector('input:not([type="checkbox"]):not([type="radio"]), textarea');
        const isMissing = !control.value.trim();
        const hasRequiredError = isMissing && (
          form.dataset.centennialSubmitAttempted === 'true' || control.getAttribute('aria-invalid') === 'true'
        );
        container.classList.toggle('centennial-required-missing', hasRequiredError);
      });
      radioFieldsets.forEach((fieldset) => {
        const hasNativeRequiredError = Boolean(fieldset.querySelector('output[role="alert"]'));
        const hasSelection = Boolean(fieldset.querySelector('input[type="radio"]:checked'));
        const hasRequiredError = !hasSelection && (
          form.dataset.centennialSubmitAttempted === 'true' || hasNativeRequiredError
        );
        fieldset.classList.toggle('centennial-required-missing', hasRequiredError);
      });
    };

    if (form.dataset.centennialRequiredValidation !== 'true') {
      form.dataset.centennialRequiredValidation = 'true';
      const markSubmitAttempted = () => {
        form.dataset.centennialSubmitAttempted = 'true';
        syncMissingFields();
        requestAnimationFrame(() => requestAnimationFrame(syncMissingFields));
      };
      form.addEventListener('click', (event) => {
        if (event.target.closest('button[type="submit"]')) markSubmitAttempted();
      }, true);
      form.addEventListener('submit', markSubmitAttempted, true);
      form.addEventListener('invalid', markSubmitAttempted, true);
      form.addEventListener('input', syncMissingFields);
      form.addEventListener('change', syncMissingFields);
      const errorObserver = new MutationObserver(syncMissingFields);
      errorObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-invalid'] });
    }
    syncMissingFields();
  }

  function injectFormStyles() {
    configureFormRoot();
    const formEmbed = document.querySelector(formEmbedSelector);
    if (!formEmbed?.shadowRoot) return false;
    if (!formEmbed.shadowRoot.getElementById(injectedStyleId)) {
      const style = document.createElement('style');
      style.id = injectedStyleId;
      style.textContent = formStyles;
      formEmbed.shadowRoot.appendChild(style);
    }
    configureRequiredValidation(formEmbed.shadowRoot);
    return true;
  }

  configureFormRoot();
  if (!injectFormStyles()) {
    const formObserver = new MutationObserver(() => {
      if (injectFormStyles()) formObserver.disconnect();
    });
    formObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-form-questions"]) return;
  try {
    
    const professionalFormRootSelector = '.centennial-professional-shopify-form [data-forms-id^="forms-root-"]';
  const professionalFormEmbedSelector = '.centennial-professional-shopify-form shopify-forms-embed';
  const professionalInjectedStyleId = 'centennial-professional-form-styles';
  const professionalFormStyles = `
    :host {
      display: block !important;
      width: 100% !important;
      max-width: 534px !important;
      color: #252525 !important;
      font-family: "Open Sans", sans-serif !important;
    }

    *, *::before, *::after {
      box-sizing: border-box;
    }

    #app-embed,
    #form-container-ref,
    form,
    [data-sizing="form-wrapper"] {
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box !important;
    }

    [class*="_formFieldContainer_"] {
      width: 100% !important;
      min-width: 0 !important;
    }

    h1, h2, h3, h4, h5, h6 {
      color: #252525 !important;
      font-family: "Montserrat", sans-serif !important;
      font-weight: 700 !important;
      letter-spacing: 0.2px !important;
      text-align: left !important;
      text-transform: uppercase !important;
    }

    h1, h2 {
      margin: 0 0 48px !important;
      font-size: 26px !important;
      line-height: 1.3 !important;
    }

    p, span, div, label, legend, input, textarea, select, button {
      font-family: "Montserrat", sans-serif !important;
    }

    label, legend {
      color: #3f3f3f !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      letter-spacing: 0.01em !important;
    }

    form[class*="_formFieldset_"] {
      gap: 24px !important;
    }

    [class*="_formFieldContainer_"] {
      gap: 16px !important;
    }

    label[class*="_formInputFieldLabel_"] {
      position: static !important;
      order: -1 !important;
      width: auto !important;
      max-width: none !important;
      margin: 0 !important;
      color: #459b45 !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      line-height: 1.2 !important;
      pointer-events: auto !important;
      transform: none !important;
      transition: none !important;
    }

    [class*="_formFieldContainer_"]:focus-within label[class*="_formInputFieldLabel_"],
    [class*="_formFieldContainer_"] label[class*="_inputFilled_"] {
      width: auto !important;
      transform: none !important;
    }

    input:not([type="checkbox"]):not([type="radio"]),
    textarea,
    select {
      width: 100% !important;
      max-width: 100% !important;
      box-sizing: border-box !important;
      height: 50px !important;
      min-height: 50px !important;
      border: 1px solid #459b45 !important;
      border-radius: 4px !important;
      background: #ffffff !important;
      color: #252525 !important;
      font-size: 16px !important;
      font-weight: 500 !important;
      line-height: 1.3 !important;
      box-shadow: none !important;
      transition: none !important;
    }

    input:not([type="checkbox"]):not([type="radio"]) {
      padding: 0 16px !important;
      line-height: 48px !important;
    }

    input:not([type="checkbox"]):not([type="radio"]):focus-visible,
    textarea:focus-visible,
    select:focus-visible {
      border-color: #459b45 !important;
      outline: 2px solid transparent !important;
      box-shadow: 0 0 0 2px rgb(69 155 69 / 20%) !important;
    }

    textarea {
      height: 150px !important;
      min-height: 150px !important;
      padding: 16px !important;
      resize: vertical !important;
    }

    [class*="_formFieldContainer_"]:has(textarea)::before {
      display: none !important;
    }

    [class*="_formFieldContainer_"] textarea,
    [class*="_formFieldContainer_"]:focus-within textarea,
    [class*="_formFieldContainer_"] [class*="_inputFilled_"] textarea {
      padding: 16px !important;
    }

    input[type="checkbox"],
    input[type="radio"] {
      accent-color: #459b45 !important;
    }

    [class*="_formPhoneInputContainer_"] {
      display: grid !important;
      grid-template-columns: 92px minmax(0, 1fr) !important;
      gap: 12px !important;
      align-items: end !important;
      width: 100% !important;
    }

    [class*="_formPhoneInputContainer_"] .phone-country-selector {
      width: 92px !important;
      min-width: 92px !important;
    }

    [class*="_formPhoneInputContainer_"] .phone-country-selector button {
      height: 50px !important;
      min-height: 50px !important;
      box-sizing: border-box !important;
      border: 1px solid #459b45 !important;
      border-radius: 4px !important;
      transition: none !important;
    }

    [class*="_formPhoneInputContainer_"] .phone-country-selector + * {
      min-width: 0 !important;
      width: 100% !important;
    }

    [class*="_formPhoneInputContainer_"] input[type="tel"] {
      min-width: 0 !important;
      width: 100% !important;
    }

    fieldset:has(input[type="radio"]) {
      border: 0 !important;
      padding: 0 !important;
    }

    fieldset:has(input[type="radio"]) > div {
      display: grid !important;
      grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
      gap: 16px !important;
    }

    label:has(input[type="radio"]) {
      position: relative !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      min-height: 40px !important;
      border: 1px solid #8a8b8d !important;
      border-radius: 4px !important;
      color: #3f3f3f !important;
      text-align: center !important;
      cursor: pointer !important;
    }

    label:has(input[type="radio"]):has(input:checked) {
      border-color: #459b45 !important;
      background: #459b45 !important;
      color: #ffffff !important;
    }

    label:has(input[type="radio"]):has(input:checked) * {
      color: #ffffff !important;
    }

    label:has(input[type="radio"]) input {
      position: absolute !important;
      width: 1px !important;
      height: 1px !important;
      opacity: 0 !important;
    }

    button[type="submit"] {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      width: 100% !important;
      height: 75px !important;
      min-height: 75px !important;
      box-sizing: border-box !important;
      padding: 0 !important;
      border: 1px solid #5bb65b !important;
      border-radius: 4px !important;
      background: #5bb65b !important;
      color: #ffffff !important;
      font-size: 20px !important;
      font-weight: 700 !important;
      letter-spacing: 0.02em !important;
      line-height: 1 !important;
      text-transform: uppercase !important;
      cursor: pointer !important;
      transition: none !important;
    }

    .centennial-required-marker {
      margin-left: 2px !important;
      color: #459b45 !important;
    }

    .centennial-required-message {
      display: none !important;
      margin-left: 8px !important;
      color: #c62828 !important;
      font-size: 12px !important;
      font-weight: 600 !important;
      line-height: 1.2 !important;
    }

    [class*="_formFieldContainer_"].centennial-required-missing input:not([type="checkbox"]):not([type="radio"]),
    [class*="_formFieldContainer_"].centennial-required-missing textarea {
      border-color: #c62828 !important;
      box-shadow: none !important;
    }

    [class*="_formFieldContainer_"].centennial-required-missing .centennial-required-marker,
    fieldset.centennial-required-missing .centennial-required-marker {
      color: #c62828 !important;
    }

    [class*="_formFieldContainer_"].centennial-required-missing .centennial-required-message,
    fieldset.centennial-required-missing .centennial-required-message {
      display: inline !important;
    }

    fieldset.centennial-required-missing label:has(input[type="radio"]) {
      border-color: #c62828 !important;
    }

    .centennial-required-missing > output[role="alert"],
    .centennial-required-missing + output[role="alert"] {
      display: none !important;
    }

    button[type="submit"]:hover {
      border-color: #459b45 !important;
      background: #459b45 !important;
      box-shadow: 0 6px 16px rgb(34 102 34 / 22%) !important;
    }

    button[type="submit"]:focus-visible {
      outline: 2px solid #252525 !important;
      outline-offset: 3px !important;
    }

    a {
      color: #459b45 !important;
    }

    @media (max-width: 479px) {
      [class*="_formPhoneInputContainer_"] {
        grid-template-columns: 82px minmax(0, 1fr) !important;
        gap: 8px !important;
      }

      [class*="_formPhoneInputContainer_"] .phone-country-selector {
        width: 82px !important;
        min-width: 82px !important;
      }

      fieldset:has(input[type="radio"]) > div {
        grid-template-columns: 1fr !important;
        gap: 8px !important;
      }

      button[type="submit"] {
        font-size: 18px !important;
      }
    }
  `;

  function configureProfessionalFormRoot() {
    const formRoot = document.querySelector(professionalFormRootSelector);
    if (!formRoot) return;
    formRoot.dataset.formsTextColor = '#252525';
    formRoot.dataset.formsButtonBackgroundColor = '#5BB65B';
    formRoot.dataset.formsButtonLabelColor = '#FFFFFF';
    formRoot.dataset.formsLinksColor = '#459B45';
    formRoot.dataset.formsTextAlignment = 'left';
    formRoot.dataset.formsAlignment = 'left';
  }

  function addProfessionalRequiredStatus(label) {
    if (!label || label.querySelector('.centennial-required-marker')) return;
    const marker = document.createElement('span');
    marker.className = 'centennial-required-marker';
    marker.setAttribute('aria-hidden', 'true');
    marker.textContent = '*';
    const message = document.createElement('span');
    message.className = 'centennial-required-message';
    message.textContent = 'Required';
    label.append(marker, message);
  }

  function configureProfessionalRequiredValidation(shadowRoot) {
    const form = shadowRoot.querySelector('form');
    if (!form) {
      if (!shadowRoot.centennialRequiredObserver) {
        shadowRoot.centennialRequiredObserver = new MutationObserver(() => {
          if (shadowRoot.querySelector('form')) {
            shadowRoot.centennialRequiredObserver.disconnect();
            configureProfessionalRequiredValidation(shadowRoot);
          }
        });
        shadowRoot.centennialRequiredObserver.observe(shadowRoot, { childList: true, subtree: true });
      }
      return;
    }

    const fieldContainers = [...form.querySelectorAll('[class*="_formFieldContainer_"]')].filter((container) => {
      return container.querySelector('input:not([type="checkbox"]):not([type="radio"]), textarea');
    });
    const radioFieldsets = [...form.querySelectorAll('fieldset')].filter((fieldset) => fieldset.querySelector('input[type="radio"]'));

    fieldContainers.forEach((container) => addProfessionalRequiredStatus(container.querySelector('label[class*="_formInputFieldLabel_"]')));
    radioFieldsets.forEach((fieldset) => addProfessionalRequiredStatus(fieldset.querySelector('legend')));

    const syncMissingFields = () => {
      fieldContainers.forEach((container) => {
        const control = container.querySelector('input:not([type="checkbox"]):not([type="radio"]), textarea');
        const isMissing = !control.value.trim();
        const hasRequiredError = isMissing && (
          form.dataset.centennialSubmitAttempted === 'true' || control.getAttribute('aria-invalid') === 'true'
        );
        container.classList.toggle('centennial-required-missing', hasRequiredError);
      });
      radioFieldsets.forEach((fieldset) => {
        const hasNativeRequiredError = Boolean(fieldset.querySelector('output[role="alert"]'));
        const hasSelection = Boolean(fieldset.querySelector('input[type="radio"]:checked'));
        const hasRequiredError = !hasSelection && (
          form.dataset.centennialSubmitAttempted === 'true' || hasNativeRequiredError
        );
        fieldset.classList.toggle('centennial-required-missing', hasRequiredError);
      });
    };

    if (form.dataset.centennialRequiredValidation !== 'true') {
      form.dataset.centennialRequiredValidation = 'true';
      const markSubmitAttempted = () => {
        form.dataset.centennialSubmitAttempted = 'true';
        syncMissingFields();
        requestAnimationFrame(() => requestAnimationFrame(syncMissingFields));
      };
      form.addEventListener('click', (event) => {
        if (event.target.closest('button[type="submit"]')) markSubmitAttempted();
      }, true);
      form.addEventListener('submit', markSubmitAttempted, true);
      form.addEventListener('invalid', markSubmitAttempted, true);
      form.addEventListener('input', syncMissingFields);
      form.addEventListener('change', syncMissingFields);
      const errorObserver = new MutationObserver(syncMissingFields);
      errorObserver.observe(form, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-invalid'] });
    }
    syncMissingFields();
  }

  function injectProfessionalFormStyles() {
    configureProfessionalFormRoot();
    const formEmbed = document.querySelector(professionalFormEmbedSelector);
    if (!formEmbed?.shadowRoot) return false;
    if (!formEmbed.shadowRoot.getElementById(professionalInjectedStyleId)) {
      const style = document.createElement('style');
      style.id = professionalInjectedStyleId;
      style.textContent = professionalFormStyles;
      formEmbed.shadowRoot.appendChild(style);
    }
    configureProfessionalRequiredValidation(formEmbed.shadowRoot);
    return true;
  }

  configureProfessionalFormRoot();
  if (!injectProfessionalFormStyles()) {
    const formObserver = new MutationObserver(() => {
      if (injectProfessionalFormStyles()) formObserver.disconnect();
    });
    formObserver.observe(document.documentElement, { childList: true, subtree: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["s-product-recommendations"]) return;
  try {
    
function ProductRecommendationsCarousel() {
    if ($('[data-swiper-scrollbar]').length) {
        let swiperScollbar = new Swiper('[data-swiper-scrollbar]', {
            spaceBetween: 0,
            slidesOffsetBefore: 0,
            scrollbar: {
                el: '.swiper-scrollbar',
                snapOnRelease: false,
                draggable: true,
            },
            freeMode: {
                enabled: true
            },
            mousewheel: {
                enabled: true,
                forceToAxis: true,
            },
            breakpoints: {
// when window width is >= 320px
                320: {
                    slidesPerView: 1,
                },
                768: {
                    slidesPerView: 1.47,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 0,
                }
            }
        });
    }
}
class ProductRecommendations extends HTMLElement {
    constructor() {
        super();
        const handleIntersection = (entries, observer) => {
            if (!entries[0].isIntersecting) return;
            observer.unobserve(this);

            fetch(this.dataset.url)
                .then(response => response.text())
                .then(text => {
                    const html = document.createElement('div');
                    html.innerHTML = text;
                    const recommendations = html.querySelector('product-recommendations');
                    if (recommendations && recommendations.innerHTML.trim().length) {
                        this.innerHTML = recommendations.innerHTML;
                        ProductRecommendationsCarousel()
                    }
                })
                .catch(e => {
                    console.error(e);
                });
        }

        new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
}

customElements.define('product-recommendations', ProductRecommendations);


  } catch(e) { console.error(e); }
})();
})();
